import { Stadium } from "../types";

export const STADIUMS: Record<string, Stadium> = {
  // ── AL EAST ────────────────────────────────────────────────────────────
  BAL: {
    team: "Baltimore Orioles",
    abbr: "BAL",
    name: "Oriole Park at Camden Yards",
    city: "Baltimore",
    state: "MD",
    lat: 39.2838,
    lng: -76.6218,
    parkFactor: 1.08,
    orientation: 55,
    dome: false,
    altitude: 53,
  },
  BOS: {
    team: "Boston Red Sox",
    abbr: "BOS",
    name: "Fenway Park",
    city: "Boston",
    state: "MA",
    lat: 42.3467,
    lng: -71.0972,
    parkFactor: 0.94,
    orientation: 95,
    dome: false,
    altitude: 21,
  },
  NYY: {
    team: "New York Yankees",
    abbr: "NYY",
    name: "Yankee Stadium",
    city: "Bronx",
    state: "NY",
    lat: 40.8296,
    lng: -73.9262,
    parkFactor: 1.18,
    orientation: 60,
    dome: false,
    altitude: 55,
  },
  TBR: {
    team: "Tampa Bay Rays",
    abbr: "TBR",
    name: "Tropicana Field",
    city: "St. Petersburg",
    state: "FL",
    lat: 27.7683,
    lng: -82.6534,
    parkFactor: 0.89,
    orientation: 0,
    dome: true,
    altitude: 15,
  },
  TOR: {
    team: "Toronto Blue Jays",
    abbr: "TOR",
    name: "Rogers Centre",
    city: "Toronto",
    state: "ON",
    lat: 43.6414,
    lng: -79.3894,
    parkFactor: 1.05,
    orientation: 0,
    dome: true,
    altitude: 300,
  },

  // ── AL CENTRAL ─────────────────────────────────────────────────────────
  CWS: {
    team: "Chicago White Sox",
    abbr: "CWS",
    name: "Guaranteed Rate Field",
    city: "Chicago",
    state: "IL",
    lat: 41.83,
    lng: -87.6338,
    parkFactor: 1.11,
    orientation: 5,
    dome: false,
    altitude: 595,
  },
  CLE: {
    team: "Cleveland Guardians",
    abbr: "CLE",
    name: "Progressive Field",
    city: "Cleveland",
    state: "OH",
    lat: 41.4962,
    lng: -81.6852,
    parkFactor: 0.97,
    orientation: 45,
    dome: false,
    altitude: 653,
  },
  DET: {
    team: "Detroit Tigers",
    abbr: "DET",
    name: "Comerica Park",
    city: "Detroit",
    state: "MI",
    lat: 42.339,
    lng: -83.0485,
    parkFactor: 0.82,
    orientation: 15,
    dome: false,
    altitude: 600,
  },
  KCR: {
    team: "Kansas City Royals",
    abbr: "KCR",
    name: "Kauffman Stadium",
    city: "Kansas City",
    state: "MO",
    lat: 39.0517,
    lng: -94.4803,
    parkFactor: 0.93,
    orientation: 35,
    dome: false,
    altitude: 910,
  },
  MIN: {
    team: "Minnesota Twins",
    abbr: "MIN",
    name: "Target Field",
    city: "Minneapolis",
    state: "MN",
    lat: 44.9817,
    lng: -93.2781,
    parkFactor: 1.04,
    orientation: 340,
    dome: false,
    altitude: 830,
  },

  // ── AL WEST ────────────────────────────────────────────────────────────
  HOU: {
    team: "Houston Astros",
    abbr: "HOU",
    name: "Minute Maid Park",
    city: "Houston",
    state: "TX",
    lat: 29.7573,
    lng: -95.3555,
    parkFactor: 0.95,
    orientation: 0,
    dome: true,
    altitude: 43,
  },
  LAA: {
    team: "Los Angeles Angels",
    abbr: "LAA",
    name: "Angel Stadium",
    city: "Anaheim",
    state: "CA",
    lat: 33.8003,
    lng: -117.8827,
    parkFactor: 0.96,
    orientation: 225,
    dome: false,
    altitude: 160,
  },
  ATH: {
    team: "Athletics",
    abbr: "ATH",
    name: "Sutter Health Park",
    city: "West Sacramento",
    state: "CA",
    lat: 38.5778,
    lng: -121.5302,
    parkFactor: 1.02,
    orientation: 20,
    dome: false,
    altitude: 25,
  },
  SEA: {
    team: "Seattle Mariners",
    abbr: "SEA",
    name: "T-Mobile Park",
    city: "Seattle",
    state: "WA",
    lat: 47.5914,
    lng: -122.3325,
    parkFactor: 0.88,
    orientation: 0,
    dome: true,
    altitude: 0,
  },
  TEX: {
    team: "Texas Rangers",
    abbr: "TEX",
    name: "Globe Life Field",
    city: "Arlington",
    state: "TX",
    lat: 32.7473,
    lng: -97.0845,
    parkFactor: 1.01,
    orientation: 0,
    dome: true,
    altitude: 616,
  },

  // ── NL EAST ────────────────────────────────────────────────────────────
  ATL: {
    team: "Atlanta Braves",
    abbr: "ATL",
    name: "Truist Park",
    city: "Cumberland",
    state: "GA",
    lat: 33.8907,
    lng: -84.4677,
    parkFactor: 1.06,
    orientation: 25,
    dome: false,
    altitude: 1050,
  },
  MIA: {
    team: "Miami Marlins",
    abbr: "MIA",
    name: "loanDepot park",
    city: "Miami",
    state: "FL",
    lat: 25.7781,
    lng: -80.2197,
    parkFactor: 0.84,
    orientation: 0,
    dome: true,
    altitude: 6,
  },
  NYM: {
    team: "New York Mets",
    abbr: "NYM",
    name: "Citi Field",
    city: "Queens",
    state: "NY",
    lat: 40.7571,
    lng: -73.8458,
    parkFactor: 0.92,
    orientation: 55,
    dome: false,
    altitude: 20,
  },
  PHI: {
    team: "Philadelphia Phillies",
    abbr: "PHI",
    name: "Citizens Bank Park",
    city: "Philadelphia",
    state: "PA",
    lat: 39.9061,
    lng: -75.1665,
    parkFactor: 1.12,
    orientation: 65,
    dome: false,
    altitude: 20,
  },
  WSN: {
    team: "Washington Nationals",
    abbr: "WSN",
    name: "Nationals Park",
    city: "Washington",
    state: "DC",
    lat: 38.873,
    lng: -77.0074,
    parkFactor: 1.03,
    orientation: 45,
    dome: false,
    altitude: 25,
  },

  // ── NL CENTRAL ─────────────────────────────────────────────────────────
  CHC: {
    team: "Chicago Cubs",
    abbr: "CHC",
    name: "Wrigley Field",
    city: "Chicago",
    state: "IL",
    lat: 41.9484,
    lng: -87.6553,
    parkFactor: 1.07,
    orientation: 90,
    dome: false,
    altitude: 595,
  },
  CIN: {
    team: "Cincinnati Reds",
    abbr: "CIN",
    name: "Great American Ball Park",
    city: "Cincinnati",
    state: "OH",
    lat: 39.0979,
    lng: -84.5082,
    parkFactor: 1.16,
    orientation: 340,
    dome: false,
    altitude: 490,
  },
  MIL: {
    team: "Milwaukee Brewers",
    abbr: "MIL",
    name: "American Family Field",
    city: "Milwaukee",
    state: "WI",
    lat: 43.028,
    lng: -87.9712,
    parkFactor: 1.01,
    orientation: 0,
    dome: true,
    altitude: 634,
  },
  PIT: {
    team: "Pittsburgh Pirates",
    abbr: "PIT",
    name: "PNC Park",
    city: "Pittsburgh",
    state: "PA",
    lat: 40.4469,
    lng: -80.0057,
    parkFactor: 0.78,
    orientation: 330,
    dome: false,
    altitude: 730,
  },
  STL: {
    team: "St. Louis Cardinals",
    abbr: "STL",
    name: "Busch Stadium",
    city: "St. Louis",
    state: "MO",
    lat: 38.6226,
    lng: -90.1928,
    parkFactor: 0.91,
    orientation: 40,
    dome: false,
    altitude: 465,
  },

  // ── NL WEST ────────────────────────────────────────────────────────────
  ARI: {
    team: "Arizona Diamondbacks",
    abbr: "ARI",
    name: "Chase Field",
    city: "Phoenix",
    state: "AZ",
    lat: 33.4453,
    lng: -112.0667,
    parkFactor: 1.02,
    orientation: 0,
    dome: true,
    altitude: 1090,
  },
  COL: {
    team: "Colorado Rockies",
    abbr: "COL",
    name: "Coors Field",
    city: "Denver",
    state: "CO",
    lat: 39.7559,
    lng: -104.9942,
    parkFactor: 1.44,
    orientation: 20,
    dome: false,
    altitude: 5200,
  },
  LAD: {
    team: "Los Angeles Dodgers",
    abbr: "LAD",
    name: "Dodger Stadium",
    city: "Los Angeles",
    state: "CA",
    lat: 34.0739,
    lng: -118.24,
    parkFactor: 0.94,
    orientation: 355,
    dome: false,
    altitude: 512,
  },
  SDP: {
    team: "San Diego Padres",
    abbr: "SDP",
    name: "Petco Park",
    city: "San Diego",
    state: "CA",
    lat: 32.7073,
    lng: -117.1566,
    parkFactor: 0.82,
    orientation: 310,
    dome: false,
    altitude: 20,
  },
  SFG: {
    team: "San Francisco Giants",
    abbr: "SFG",
    name: "Oracle Park",
    city: "San Francisco",
    state: "CA",
    lat: 37.7786,
    lng: -122.3893,
    parkFactor: 0.85,
    orientation: 295,
    dome: false,
    altitude: 0,
  },
};

// ── HELPERS ──────────────────────────────────────────────────────────────────

export function getStadium(abbr: string): Stadium | undefined {
  return STADIUMS[abbr.toUpperCase()];
}

export function getWindEffect(
  windDeg: number,
  stadium: Stadium
): "in" | "out" | "cross" | "dome" {
  if (stadium.dome) return "dome";
  const inBearing = stadium.orientation;
  const outBearing = (stadium.orientation + 180) % 360;
  const diffIn = Math.abs(((windDeg - inBearing + 540) % 360) - 180);
  const diffOut = Math.abs(((windDeg - outBearing + 540) % 360) - 180);
  if (diffIn <= 45) return "in";
  if (diffOut <= 45) return "out";
  return "cross";
}

export function parkFactorScore(abbr: string): number {
  const stadium = getStadium(abbr);
  if (!stadium) return 50;
  const clamped = Math.max(0.7, Math.min(1.5, stadium.parkFactor));
  return Math.round(((1.5 - clamped) / (1.5 - 0.7)) * 100);
}
